const filePermissionTypes = ['read', 'write', 'modify'];
/**
 * Applies the folder's permissions difference to a target file's permissions
 * @param targetPermissions DocumentPermissions to which the diff is applied
 * @param diffToApply a difference in permissions to apply to targetPermissions
 */
export function applyPermissionsDifferenceToFile(targetPermissions, diffToApply) {
    const nextPermissionMaps = filePermissionsToMap(targetPermissions);
    // remove deleted permissions
    for (const pType of filePermissionTypes) {
        const diff = diffToApply[pType];
        if (diff) {
            diff.removed.accountIds.forEach((id) => nextPermissionMaps.accountMap.delete(id));
            diff.removed.organizationIds.forEach((id) => nextPermissionMaps.orgMap.delete(id));
            diff.removed.systemRoles.forEach((role) => nextPermissionMaps.systemRoleMap.delete(role));
        }
    }
    // add new permissions
    for (const pType of filePermissionTypes) {
        const diff = diffToApply[pType];
        if (diff) {
            diff.added.accountIds.forEach((id) => nextPermissionMaps.accountMap.set(id, pType));
            diff.added.organizationIds.forEach((id) => nextPermissionMaps.orgMap.set(id, pType));
            diff.added.systemRoles.forEach((id) => nextPermissionMaps.systemRoleMap.set(id, pType));
        }
    }
    const result = mapToFilePermissions(nextPermissionMaps.accountMap, nextPermissionMaps.orgMap, nextPermissionMaps.systemRoleMap);
    // public property is not inherited, so keep it from the current permissions object
    if ('public' in targetPermissions) {
        result.public = targetPermissions.public;
    }
    return result;
}
function filePermissionsToMap(permissions) {
    const accountMap = new Map();
    const orgMap = new Map();
    const systemRoleMap = new Map();
    filePermissionTypes.forEach((pType) => {
        const permissionsGroup = permissions[pType];
        if (permissionsGroup) {
            permissionsGroup.accountIds.forEach((userId) => {
                accountMap.set(userId, pType);
            });
            permissionsGroup.organizationIds.forEach((orgId) => {
                orgMap.set(orgId, pType);
            });
            permissionsGroup.systemRoles.forEach((role) => {
                systemRoleMap.set(role, pType);
            });
        }
    });
    return { accountMap, orgMap, systemRoleMap };
}
function mapToFilePermissions(accountMap, orgMap, systemRoleMap) {
    const result = {};
    accountMap.forEach((pType, accountId) => {
        var _a;
        if (!result[pType]) {
            result[pType] = { accountIds: [], organizationIds: [], systemRoles: [] };
        }
        (_a = result[pType]) === null || _a === void 0 ? void 0 : _a.accountIds.push(accountId);
    });
    orgMap.forEach((pType, orgId) => {
        var _a;
        if (!result[pType]) {
            result[pType] = { accountIds: [], organizationIds: [], systemRoles: [] };
        }
        (_a = result[pType]) === null || _a === void 0 ? void 0 : _a.organizationIds.push(orgId);
    });
    systemRoleMap.forEach((pType, role) => {
        var _a;
        if (!result[pType]) {
            result[pType] = { accountIds: [], organizationIds: [], systemRoles: [] };
        }
        (_a = result[pType]) === null || _a === void 0 ? void 0 : _a.systemRoles.push(role);
    });
    return result;
}
